import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';
import { BlocksIconDiamondFilled } from 'blocks-nextjs/blocks-web-components/components/icon/icons/diamond-filled';

export const CatIconDiamondFilled = createComponent({
  react: React,
  tagName: 'cat-icon-diamond-filled',
  elementClass: BlocksIconDiamondFilled
});
